import React from 'react'
import pluralize from 'pluralize'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import AsyncElements from '../../components/AsyncElements'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import { ApiHost } from '../../config'
import '../../assets/css/pages/class_management/google-classroom-popup.css'

class GoogleClassroomPopup extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasAuthorized: false }
  }

  componentDidMount() {
    this.props.fetchClassrooms()
    this.setState({ hasAuthorized: true })
  }

  handleAuth = ()=> {
    // Store the section id so the user will be redirected there after auth for a smoother import process
    localStorage.setItem('sectionId', this.props.section.id)
    window.location = this.props.authLink
  }

  googleAuthRequired = ()=> this.state.hasAuthorized && this.props.authLink

  render() {
    const { wasSuccessful, importClassroomStudents, isImporting, importErrors, section, classrooms, authLink, handleSelectClassroom, handleCustomCourse, onClose, currentGoogleClassroomId, course, courses, processedIds, onSubmitNew, onSubmitEdit, classroomData, isSubmitting, submitError, isFetching, fetchErrors } = this.props

    return(
      <div className='popup-content google-classroom-popup popup dialog simple-popup popup dialog--open'>
        <div onClick={()=>onClose(section.id)} className='popup-background'></div>
        <div className="dialog__content">
          <div className="container-fluid">
            {isImporting && <div className='importing-shield'>
              <img className='loading-gif' src={loadingGif}/>
            </div>}

            <div className="dialog__overview">
              <h1>Import</h1>
              <h2>from Google Classroom</h2>
              <button onClick={()=>onClose(section.id)} className="popup-close close action top-right"><i className="fa fa-times"></i></button>
              <AsyncElements isLoading={isFetching} loadingMessage={'This may take a moment'}>
                {wasSuccessful &&
                  <div className='success'>Success!</div>
                }
                {this.googleAuthRequired() &&
                  <div>
                    <p>In order to import your classes, you'll need to grant Tyto Online access to your classroom data. You'll briefly be redirected to Google's site.</p>
                    <br/>
                    <button type='button' onClick={this.handleAuth} className='btn btn-primary'>Authorize Access</button>
                    <br/><br/><br/>
                  </div>
                }
                {!this.googleAuthRequired() &&
                  <div>
                    {_.map(classrooms, c =>
                      <div className='classroom' key={c.id}>
                        <p className='title'>{c.name}</p>
                        <p className='count'>{pluralize('Student', c.studentCount, true)}</p>
                        <button onClick={()=>importClassroomStudents(c.id,section.id)} type='button' className='btn btn-primary'>
                          Import Students
                        </button>
                      </div>
                    )}
                    {_.isEmpty(classrooms) && _.isEmpty(fetchErrors) &&
                      <div>
                        <h3>No Classrooms were found.</h3>
                        <p>You can <u><a href='https://classroom.google.com/' target='_blank'>create some</a></u> or <u><a href={`${ApiHost()}auth/google_oauth2/callback`}>sign in again</a></u> with a different Google account.</p>
                      </div>
                    }
                    {!_.isEmpty(fetchErrors) && <p className='error'>{fetchErrors.join()}</p> }
                    {!_.isEmpty(importErrors) && <p className='error'>{importErrors.join()}</p> }
                  </div>
                }
                <br/><br/>
              </AsyncElements>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleClassroomPopup
